import { inject, provide, ComputedRef, InjectionKey } from "vue";
import type {
  IProductTableData,
  IProductCategory,
} from "@/types/db/product-category";

export type ProductsContext = {
  refreshPeriod: (event: Event, product: IProductTableData) => boolean;
  selectProduct: (
    event: Event | null,
    product: IProductCategory
  ) => Promise<boolean>;
  openCalendar: (id: number) => boolean;
  allowSelectProduct: (product: IProductTableData) => boolean;
  canSell: ComputedRef<boolean>;
  productsPssCount: ComputedRef<Record<number, number>>;
  getTranslationForProducts: (localeObject: any) => string;
  getPictureUrl: (pc: IProductCategory) => string;
};

const KEY: InjectionKey<ProductsContext> = Symbol("products-context");

/**
 * Provide handlers + reactive state to descendant cell components.
 * Called once from Products.vue setup.
 *
 * @param {ProductsContext} ctx - Handlers and computed refs.
 * @returns {boolean} Sentinel.
 */
export function provideProductsContext(ctx: ProductsContext): boolean {
  provide(KEY, ctx);

  return true;
}

/**
 * Inject the products context. Throws when called outside a Products.vue tree.
 *
 * @returns {ProductsContext}
 */
export function useProductsContext(): ProductsContext {
  const ctx = inject(KEY);

  if (!ctx) {
    throw new Error("useProductsContext: called outside Products.vue tree");
  }

  return ctx;
}
